import UtmTagsInjector from './UtmTagsInjector';

export default UtmTagsInjector;
